import { CLAIM_MODULE_OPTIONS } from "@/constants/claim-options";
import type {
    Claim,
    ClaimAssignee,
    ClaimAssigneeBlockedModulesEnum,
    UpdateClaimAccessRequestBlockedModulesEnum,
} from "@/api/generated/client/models";

const CLAIM_TO_UPDATE_MODULE: Record<
    ClaimAssigneeBlockedModulesEnum,
    UpdateClaimAccessRequestBlockedModulesEnum
> = {
    comparisons: "comparisons",
    documents: "documents",
    photos: "photos",
    links: "links",
    tasks: "tasks",
    supplements: "supplements",
    forms: "forms",
    financials: "financials",
    emails: "emails",
    notes: "notes",
};

const VALID_UPDATE_MODULES = new Set<UpdateClaimAccessRequestBlockedModulesEnum>(
    CLAIM_MODULE_OPTIONS.map((option) => option.value),
);

export function getBlockedModules(
    assignee: ClaimAssignee,
): UpdateClaimAccessRequestBlockedModulesEnum[] {
    return (assignee.blockedModules ?? [])
        .map((module) => CLAIM_TO_UPDATE_MODULE[module as ClaimAssigneeBlockedModulesEnum])
        .filter(
            (value): value is UpdateClaimAccessRequestBlockedModulesEnum =>
                value !== undefined && VALID_UPDATE_MODULES.has(value),
        );
}

export function getNextBlockedModules(
    currentModules: UpdateClaimAccessRequestBlockedModulesEnum[],
    module: UpdateClaimAccessRequestBlockedModulesEnum,
    checked: boolean,
): UpdateClaimAccessRequestBlockedModulesEnum[] {
    const next = new Set(currentModules);
    if (checked) {
        next.add(module);
    } else {
        next.delete(module);
    }

    return Array.from(next).filter((value) => VALID_UPDATE_MODULES.has(value));
}

export function isModuleBlockedForUser(
    claim: Pick<Claim, "assignees">,
    userId: number | undefined,
    module: ClaimAssigneeBlockedModulesEnum,
): boolean {
    if (!userId) {
        return false;
    }

    const currentAssignee = claim.assignees?.find((assignee) => assignee.userId === userId);
    return currentAssignee?.blockedModules?.includes(module) ?? false;
}
